import { render } from "./PartsSale.vue?vue&type=template&id=6d34c9b6&scoped=true&ts=true"
import script from "./PartsSale.vue?vue&type=script&lang=ts"
export * from "./PartsSale.vue?vue&type=script&lang=ts"

import "./PartsSale.vue?vue&type=style&index=0&id=6d34c9b6&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d34c9b6"]])

export default __exports__